import { ICommunication } from '.';

export const communicationsSelector = (state: any): ICommunication[] => state.communications;
